export const SET_HEADER_INFO = "answerHeader/SET_HEADER_INFO";
export const OPEN_MENU = "answerHeader/OPEN_MENU";
export const CLOSE_MENU = "answerHeader/CLOSE_MENU";
export const START_EFFECT = "answerHeader/START_EFFECT";
export const FINISH_EFFECT = "answerHeader/FINISH_EFFECT";
export const SET_ANSWER_TOKEN = "answerHeader/SET_ANSWER_TOKEN";

// Action
export const setHeaderInfo = headerInfo => ({
  type: SET_HEADER_INFO,
  headerInfo
});
export const openMenu = event => ({
  type: OPEN_MENU,
  event
});
export const closeMenu = () => ({
  type: CLOSE_MENU
});

export const startEffect = () => ({
  type: START_EFFECT
});

export const finishEffect = () => ({
  type: FINISH_EFFECT
});

export const setAnswerToken = token => ({
  type: SET_ANSWER_TOKEN,
  token
});

// Reducer
const initialState = {
  customerLogo: null,
  customerName: "",
  surveyName: "",
  isOpenMenu: false,
  menuAnchorEl: null,
  isEffecting: false,
  answerToken: ""
};

const answerHeader = (state = initialState, action) => {
  switch (action.type) {
    case SET_HEADER_INFO: {
      const { customerName, customerLogo, surveyName } = action.headerInfo;
      return {
        ...state,
        customerName,
        customerLogo,
        surveyName
      };
    }

    case OPEN_MENU: {
      return {
        ...state,
        menuAnchorEl: action.event.currentTarget,
        isOpenMenu: true
      };
    }

    case CLOSE_MENU: {
      return { ...state, isOpenMenu: false };
    }

    case START_EFFECT: {
      return { ...state, isEffecting: true };
    }

    case FINISH_EFFECT: {
      return { ...state, isEffecting: false };
    }

    case SET_ANSWER_TOKEN: {
      return { ...state, answerToken: action.token };
    }

    default: {
      return state;
    }
  }
};

export default answerHeader;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerHeader.js